import { Form, Modal, Select } from 'antd';
import React, { ReactElement, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { administratorRoleAction } from '~Administrators/actions';
import IAdministrator from '~Api/Administrator/IAdministrator';
import RoleEnum from '~Api/Administrator/RoleEnum';
import ModalStateEnum from '~UI/ModalStateEnum';
import { IDictionary } from '~utilities/IDictionary';

interface IDefaultedValues {
    role: RoleEnum;
}

export default function RoleModal(props: {
    administrator: IAdministrator;
    isOpen: ModalStateEnum;
    onCancel: () => void;
}): ReactElement {
    const { isOpen, administrator, onCancel } = props;
    const [dirtyFields, setDirtyFields] = useState<IDictionary<boolean>>({});
    const [role, setRole] = useState<RoleEnum>(null);

    const dispatch: Dispatch = useDispatch();

    const getDefaultedValues: () => IDefaultedValues = () => ({
        role: dirtyFields.role ? role : administrator.role ?? null,
    });

    const { role: defaultedRole } = getDefaultedValues();

    const onChangeRole: (value: RoleEnum) => void = useCallback((value: RoleEnum) => {
        setRole(value);
        setDirtyFields((prev: IDictionary<boolean>) => ({ ...prev, role: true }));
    }, []);

    const onClickCancel: () => void = useCallback(() => {
        setRole(null);
        setDirtyFields({});
        onCancel();
    }, [
        onCancel,
    ]);

    const onClickUpdate: () => void = useCallback(() => {
        dispatch(administratorRoleAction(administrator.uuid, defaultedRole));
        onClickCancel();
    }, [
        administrator.uuid,
        dispatch,
        onClickCancel,
        defaultedRole,
    ]);

    return (
        <Modal
            okText='Update'
            onCancel={onClickCancel}
            onOk={onClickUpdate}
            open={ModalStateEnum.Open === isOpen}
            title='Role'
            wrapClassName='administrator-role-modal'
        >
            <Form.Item label='Role' className='role'>
                <Select onChange={onChangeRole} value={defaultedRole}>
                    <Select.Option value={null}>None</Select.Option>
                    <Select.Option key={RoleEnum.BusinessDevelopmentManager} value={RoleEnum.BusinessDevelopmentManager}>Business Development Manager</Select.Option>
                    <Select.Option key={RoleEnum.CreditManager} value={RoleEnum.CreditManager}>Credit Manager</Select.Option>
                    <Select.Option key={RoleEnum.InternalBusinessDevelopmentManager} value={RoleEnum.InternalBusinessDevelopmentManager}>Internal Business Development Manager</Select.Option>
                    <Select.Option key={RoleEnum.InvestorManager} value={RoleEnum.InvestorManager}>Investor Manager</Select.Option>
                    <Select.Option key={RoleEnum.LoanManager} value={RoleEnum.LoanManager}>Loan Manager</Select.Option>
                    <Select.Option key={RoleEnum.SeniorBusinessDevelopmentManager} value={RoleEnum.SeniorBusinessDevelopmentManager}>Senior Business Development Manager</Select.Option>
                    <Select.Option key={RoleEnum.SeniorCreditManager} value={RoleEnum.SeniorCreditManager}>Senior Credit Manager</Select.Option>
                    <Select.Option key={RoleEnum.SeniorInvestorManager} value={RoleEnum.SeniorInvestorManager}>Senior Investor Manager</Select.Option>
                    <Select.Option key={RoleEnum.SeniorLoanManager} value={RoleEnum.SeniorLoanManager}>Senior Loan Manager</Select.Option>
                    <Select.Option key={RoleEnum.SuperAdmin} value={RoleEnum.SuperAdmin}>Super Admin</Select.Option>
                </Select>
            </Form.Item>
        </Modal>
    );
}